import config from "../config";
import Cookies from "js-cookie";

const defaultHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json",
  Source: "bo",
};

export const getHeaders = () => {
  const token = Cookies.get("accessTokenModeration");
  const headers = { ...defaultHeaders };
  if (token) {
    headers["Authorization"] = token;
  }
  return headers;
};

export const post = async (route, object) => {
  const response = await fetch(config.environment.apiUrl + route, {
    method: "post",
    headers: getHeaders(),
    body: JSON.stringify(object),
  }).then((res) => res.json());
  return response.status === "success"
    ? response.data
    : { error: response.message };
};

export const get = async (route) => {
  const response = await fetch(config.environment.apiUrl + route, {
    method: "get",
    headers: getHeaders(),
  }).then((res) => res.json());
  return response.status === "success"
    ? response.data
    : { error: response.message };
};

export const del = async (route) => {
  const response = await fetch(config.environment.apiUrl + route, {
    method: "delete",
    headers: getHeaders(),
  }).then((res) => res.json());
  return response.status === "success"
    ? response.data
    : { error: response.message };
};

export const put = async (route, object) => {
  const response = await fetch(config.environment.apiUrl + route, {
    method: "put",
    headers: getHeaders(),
    body: JSON.stringify(object),
  }).then((res) => res.json());
  return response.status === "success"
    ? response.data
    : { error: response.message };
};

export const getS3Url = async (type) => {
  const res = await get(`/s3/bucket/url?type=${type}`);
  return res;
};

export const uploadFile = async (file) => {
  let type = file.type;
  const { url } = await getS3Url(type);
  const headersContent = {
    "Content-Type": file.type,
    Accept: "application/json",
  };
  const headers = new Headers(headersContent);
  const response = await fetch(url, {
    method: "PUT",
    body: file,
    headers,
  });

  if (!response) return null;
  let resUrl = new URL(response.url);

  return resUrl.protocol + "//" + resUrl.host + resUrl.pathname;
};
